
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateInstantTaskForm } from '@/services/Backup/forms/CreateBackupForm';
import { TaskRepositoryInterface } from '@/services/Backup/interfaces';
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import ServerPicker from "@/components/server/ServerPicker.vue";
import BackupServerPicker from "@/components/backups/BackupServerPicker.vue";
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  inject: [
    'taskRepository',
  ],
  components: {
    BackupServerPicker,
    ServerPicker,
    PageHeader,
  },
})
export default class CreateTask extends Vue {
  public taskRepository: TaskRepositoryInterface;

  public isLoading: boolean = false;
  public instantTaskForm: WPXFormValue<CreateInstantTaskForm> = new WPXFormValue(CreateInstantTaskForm);

  public types = [
    'Backup',
    'Forget',
    'Prune'
  ];

  public async createInstantTask(): Promise<void> {
    try {
      this.isLoading = true;

     await this.taskRepository.createInstantTask({
       type: this.instantTaskForm.data.type,
       targetServerId: this.instantTaskForm.data.targetServerId,
      });

      this.$infoDialog.show(`Instant task created!`);

      await this.$router.push({ name: "task_list" })
    } catch (err) {
      this.onError(err);
    } finally {
      this.isLoading = false;
    }
  }

  public async created(): Promise<void> {}

  private onError(err: unknown): void{
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}
